import React, { useMemo } from 'react';
import classnames from 'classnames';
import GeneralImageNew, { IGeneralImageDomain } from '@gp/components/GeneralImageNew';
import CoverName from '@gp/components/CoverUploader/components/CoverName';
import CoverInfo from '@gp/components/CoverUploader/components/CoverInfo';
import CoverBtns, { ICoverBtnsProps } from '@gp/components/CoverUploader/components/CoverBtns';
import { Icon } from 'tea-component';
// @ts-ignore
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { noop } from '@/pages/home/utils/utils';
import {
  IStatusImageItemProps,
  IStatusImage,
  ImageStatus,
  ImageError,
} from '@/pages/home/components/ImagesUploader/types.d';
import type { IBaseProps } from '@home/types/common';
import type { ICover } from '@gp/components/CoverUploader/types';
import NEW_DELETE from '@gp/assets/svg/new-delete-icon.svg';
import './index.scss';

// 组件props类型
interface ICoverCardProps extends IBaseProps, ICoverBtnsProps {
  // domain，比如说user、game、studio，不同的domain有不同的默认图片
  domain?: IGeneralImageDomain;
  // 默认图片，优先级高于domain
  errorImg?: string;
  // 上传进度
  percents?: number;
  // 文件类型、文件大小限制这部分的提示内容
  tips?: string | React.ReactElement;
  // cover的dataURL，用来展示图片
  cover?: string;
  // cover信息
  data?: ICover;
  onDelete?: any;
}

const getProgress = (progress: number | undefined): number => {
  const isNumber = typeof progress === 'number';
  const flag1 = (progress as number) > 0 && (progress as number) < 100;
  const flag2 = progress === 0 || progress === 100;
  return isNumber && (flag1 || flag2) ? progress : 100;
};

const StatusImage: React.FC<ICoverCardProps> = (props) => {
  const {
    style,
    className,
    domain = 'game',
    errorImg,
    status = 'success',
    percents = 0,
    cover,
    onDelete,
    metaData,
  } = props;

  const { formatMessage } = useIntl();

  // 压缩，或者上传状态
  const renderLoadingStatusUI = () => {
    const safeProgress = getProgress(percents);

    return (
      <div className="dbg-image-upload-btn-status-image-components-loading">
        <Icon type="loading" className="font-icon" />
        <div
          className="loading-state"
          style={{
            width: safeProgress === 0 ? 0 : `${safeProgress}%`,
          }}
        />
        <span className="font-text">
          {formatMessage({
            id: 'dbh_feedback_uploading_text',
            defaultMessage: 'Uploading…',
          })}
          {!Number.isNaN(percents) ? `${percents}%` : ''}
        </span>
      </div>
    );
  };

  const isLoading = useMemo(() => {
    return status === 'uploading';
  }, [status]);

  return (
    <div
      style={style}
      className={classnames('dbg-image-upload-btn-status-image', className, {
        'is-error': status === 'error',
      })}
    >
      {isLoading && (
        <div className="dbg-image-upload-btn-status-image-components">
          {renderLoadingStatusUI()}
        </div>
      )}
      {!isLoading && (
        <div className="dbg-image-upload-btn-content">
          <GeneralImageNew
            className="dbg-image-upload-btn-status-image-components"
            domain={domain}
            errorImg={errorImg}
            needBorderRadius={false}
            src={cover || ''}
          />
          <i
            onClick={() => {
              onDelete?.(metaData);
            }}
          >
            <div className="dbg-image-upload-btn-content-icon-img">
              {/* <img className="dbg-restricted-content-icon-img" src={NEW_DELETE} alt="" /> */}
            </div>
            {/* <SvgIcon type="clonse" className="unloadModal-showImg-clonse" /> */}
          </i>
        </div>
      )}
    </div>
  );
};

export default StatusImage;
